/* eslint-disable */
import { Component } from 'react';
import PropTypes from 'prop-types';
import iconClose from '../../icons/close.svg';
import '../../styles/message.scss';
import iconSuccess from '../../icons/succes.svg';
import iconError from '../../icons/error.svg';
import iconInfo from '../../icons/info.svg';

class Message extends Component {
  render() {
    if (!this.props.open) {
      return <></>;
    }
    let notificationIconType;
    switch (this.props.type) {
      case 'success':
        notificationIconType = iconSuccess;
        break;
      case 'error':
        notificationIconType = iconError;
        break;
      case 'info':
        notificationIconType = iconInfo;
        break;
      default:
        notificationIconType = iconInfo;
    }
    return (
      <div className='message-container'>
        <div className='close-icon-box'>
          <img onClick={this.props.onClick} src={iconClose} />
        </div>
        <div className='message-body'>
          <div className='type-icon-container'>
            <img src={notificationIconType} />
          </div>
          <div className='text-container'>
            <span className='notification-text' dangerouslySetInnerHTML={{ __html: this.props.message }} />
          </div>
        </div>
      </div>
    );
  }
}

Message.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Message;
